import { render, staticRenderFns } from "./Workflow-PolicyFinder.vue?vue&type=template&id=aaaa7f84&"
import script from "./Workflow-PolicyFinder.vue?vue&type=script&lang=js&"
export * from "./Workflow-PolicyFinder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports